module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0009.jpg?v=2744dcfc";